import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router';
import SubmitClaimPage from './submit-claim/pages/SubmitClaimPage';
import { AuthGuard } from './signin/components/AuthGuard';

const ClaimsListPage = lazy(() => import('./claims-list/pages/ClaimsListPage'));
const ClaimDetailPlaceholder = lazy(() => import('./claim-details/pages/ClaimDetailPlaceholder'));
const EditClaimPage = lazy(() => import('./edit-claim/pages/EditClaimPage'));
const EncounterDetailsPage = lazy(() => import('./encounter-details/pages/EncounterDetailsPage'));
const UploadsPage = lazy(() => import('./uploads/pages/UploadsPage'));
const GapRequestPage = lazy(() => import('./iframes/pages/GapRequestPage'));
const PowerBiReportsPage = lazy(() => import('./iframes/pages/PowerBiReportsPage'));

import { Box, CircularProgress } from '@mui/material';

const LoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <CircularProgress size={32} />
  </Box>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <ClaimsListPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/submit',
    element: (
      <AuthGuard>
        <SubmitClaimPage />
      </AuthGuard>
    ),
  },
  {
    path: '/claims',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <ClaimsListPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/claims/:id',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <ClaimDetailPlaceholder />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/view/:encounterId',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <EncounterDetailsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/edit/:encounterId',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <EditClaimPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/uploads',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <UploadsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/gap-request',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <GapRequestPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/powerbi-reports',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingFallback />}>
          <PowerBiReportsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
]);
